import "../node_modules/bootstrap-icons/icons/chevron-left.svg";
import "../node_modules/bootstrap-icons/icons/chevron-right.svg";
import "./images/BRD_LOGO.svg";
import "./styles/scss/main.scss";
import "../template-parts/hero-carousel/hero-carousel";
import "../template-parts/hero-carousel/hero-carousel.scss";
import "../template-parts/nav/nav";
import "../template-parts/single/flex-centered-portrait-image/flex-centered-portrait-image";
import "../template-parts/single/flex-full-width-image/flex-full-width-image";
import "../template-parts/single/flex-two-col-image/flex-two-col-image";
import "../template-parts/single/flex-image-resolver/flex-image-resolver.scss";
import "./scripts/enquiry-form";
import "./scripts/signup-form";
import "./scripts/projects-grid";

import bootstrap from "bootstrap";
import mediumZoom from "medium-zoom";
import { popper } from "@popperjs/core";

mediumZoom("img.data-zoomable");
